import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ResponseHttpError, ResponseHttpSuccess} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {environment} from "projects/store/src/environments/environment";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService} from "library";
import {UtilService} from "library";
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

@Component({
  selector: 'app-luki-client',
  templateUrl: './luki-client.component.html',
})
export class LukiClientComponent implements OnInit {
  submitted: boolean = false;
  loading: boolean = false;
  country = environment.global.country;
  id: string;
  formLuki!: FormGroup;
  lukiStatus = signal<any>({});


  @Input( {required: true} )visibleLukiModal!: boolean;

  @Output() onClose = new EventEmitter<boolean>();
  @Output() onLukiStatus = new EventEmitter<any>();
  @Output() gotoStepEvent = new EventEmitter()

  constructor(private requestService: RequestService,
              private customMessageService: CustomMessageService,
              private utilService: UtilService,
              private route: ActivatedRoute,
              private macroFlowService: MacroFlowService) {
    this.id = this.route.snapshot.params['request_id'];

    this.formLuki = new FormGroup({
      luki_wallet_number: new FormControl(null, [Validators.required])
    });
  }


  ngOnInit() {
    this.loadLukiAppStatus();
  }


  onLukiPayment() {
    this.submitted = true;
    if(this.formLuki.invalid) {
      return;
    }
    this.loading = this.utilService.enablePageLoading();
    this.requestService.doLukiCashIn(this.id, this.formLuki.value).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Created) {
          this.onGotoStep( this.macroFlowService.getKredicashClienteFlow(), SalesWorkflowSteps['final-message-luki']);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loading = this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.NotAcceptable) {
          // TODO como manejar el error
          this.customMessageService.error(error.error.data.message);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.loading = this.utilService.disablePageLoading();
      }
    });
  }

  loadLukiAppStatus() {
    this.utilService.enablePageLoading();
    this.requestService.getClientLukiAppStatus(this.id).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.lukiStatus.set(resp.body.data);
          this.formLuki.patchValue({luki_wallet_number: this.lukiStatus()?.luki_wallet_number})
          this.onLukiStatus.emit(this.lukiStatus());
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading()
      },
      error: (error: ResponseHttpError) => {
        this.utilService.disablePageLoading()
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  onCloseModal(){
    this.onClose.emit( false);
  }

  onGotoStep(flowCode: string, stepCode: string) {
    this.gotoStepEvent.emit({ flowCode, stepCode });
  }
}
